export default __webpack_public_path__ + "maps-examples-tracking-mode-thumbnail-480-7718320230b3d99a5238a15b3c2d25fa.png";